// HostingDetails and the ScheduledTasks page both need to know what types of capabilities
// are associated to scheduled tasks.

const scheduledTaskCapabilities = ['autoReboot'];

export default scheduledTaskCapabilities;
